// Auto-generated by scripts/generate-version-json.js — do not edit manually.
export const APP_VERSION = "3.6";
export const APP_BUILD_TIME = "2026-06-23T01:07:56.398Z";
